import { createSlice } from '@reduxjs/toolkit'

import { fetchHomePageRevision } from 'redux/thunks/HomePageRevision'
import { IHomePageRevisionProps } from 'types/HomePageRevision'

const initialState: IHomePageRevisionProps = {
  lastRevision: {},
  lastPublishedRevision: {},
  fetching: false,
  doneFetching: false,
  fetchError: '',
  queries: {
    page: 1,
    per_page: 1,
  },
  filters: {
    sort: {
      id: 'desc',
    },
  },
}

export const homePageRevision = createSlice({
  name: 'homePageRevision',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchHomePageRevision?.pending?.toString()]: (state) => {
      state.fetching = true
    },
    [fetchHomePageRevision?.fulfilled?.toString()]: (state, action) => {
      state.fetching = false
      state.doneFetching = true
      state.fetchError = ''
      state.lastPublishedRevision = action.payload
    },
    [fetchHomePageRevision?.rejected?.toString()]: (state, action) => {
      state.fetching = false
      state.doneFetching = true
      state.fetchError = action.errorMessage
    },
  },
})

export default homePageRevision.reducer
